module.exports = __webpack_public_path__ + "img/zhongYao3.d12f8d9d.png";